export const loginByCodeForm = {
  Code: 'code',
  SignInBtn: 'sign-in-btn',
  InformativeLabel: 'informative-label',
  BackBtn: 'back-btn',
};
